import Modal from "@mui/material/Modal";
import React from "react";
import {
  IconButton,Stack, Typography
} from "@mui/material";
import {IconX} from "@tabler/icons-react";
import {VarForm} from "../vars/VarForm";
import {v4 as uuid} from "uuid";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: "280px",
  maxWidth: "sm",
  width: "90%",
  maxHeight: "80vh",
  bgcolor: 'background.paper',
  borderRadius: 0,
  border: '0px solid #000',
  boxShadow: 24,
  p: 3,
  overflowY: "auto"
};

//Selected var is index
export const CreateVariableModal = ({open, handleClose, editParam, params = [], isForm, onUpdateParams, project}) => {
  const onSubmit = (param) => {
    let newParams = [...params];
    if (editParam?.uid) {
      newParams = newParams?.map(item => item?.uid === param?.uid ? {...param} : {...item});
    } else {
      param.uid = uuid();
      newParams.push({...param});
    }
    onUpdateParams(newParams);
    handleClose();
  }

  const onDelete = () => {
    let newParams = params?.filter((p) => p?.uid !== editParam?.uid);
    onUpdateParams(newParams);
    handleClose();
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Stack direction={"column"} gap={2} sx={style}>
        <Stack direction={"row"} gap={1} justifyContent={"space-between"} alignItems={"center"}>
          <Typography variant={"h4"} fontWeight={600}>{editParam?.uid ? "Update" : "Create new"} variable</Typography>
          <IconButton onClick={handleClose}>
            <IconX/>
          </IconButton>
        </Stack>
       <VarForm
        handleClose={handleClose}
        onDelete={onDelete}
        onSubmit={onSubmit}
        isForm={isForm}
        selectedParam={editParam}
        project={project}
       />
      </Stack>
    </Modal>
  )
}
